import { LiveAnnouncer } from '@angular/cdk/a11y';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthenticationService } from '@core/authentication.service';
import { MasqueradeService } from '@core/services/masquerade/masquerade.service';
import { UserService } from '@core/user.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RoleType } from '@shared/enums/role-type';
import {
  BrandedUserManagementTableComponent
} from '@shared/manage-users/branded-user-management-table/branded-user-management-table.component';
import { ToastrService } from 'ngx-toastr';
import { SchoolsFacade } from 'src/app/schools/store/schools.facade';

// Use the user-management template and overwrite methods as needed
@Component({
  selector: 'zbp-branded-students-table',
  templateUrl: '../../branded-user-management-table/branded-user-management-table.component.html',
  styleUrls: ['../../branded-user-management-table/branded-user-management-table.component.scss'],
  standalone: false
})
export class BrandedStudentsTableComponent extends BrandedUserManagementTableComponent {
  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public authService: AuthenticationService,
    public userService: UserService,
    public schoolsFacade: SchoolsFacade,
    public modalService: NgbModal,
    public toastr: ToastrService,
    public masqueradeService: MasqueradeService,
    public liveAnnouncer: LiveAnnouncer,
  ) {
    super(
      router,
      route,
      authService,
      userService,
      schoolsFacade,
      modalService,
      toastr,
      masqueradeService,
      liveAnnouncer,
    );

    this.showExternalId = true;
    this.showUserName = true;
    this.exportFileName = 'import_students';
    this.role = RoleType.Student;
    this.roleName = 'student';
    this.pluralName = 'Students';
    this.htmlIdName = 'Student';
    this.confirmList = [
      'This user will be removed from all classes in this school.'
    ];
  }
}
